import routes from "../../../utils/routes";
import RadioCss from "../Style.module.scss";
import { LogoPlayerRow} from "../Image/LogoPlayerRow";
import { FlowText } from "../../FlowText";
import {RouteLink} from "../../RouteLink";
import {useNowSongKey} from "../../../queriesKeys/useNowSongKey";
import {useRef} from "react";
import {useQuery} from "@tanstack/react-query";
import {useIsSafari} from "../../../contexts/useIsSafari";
import {useLyrics} from "../../../contexts/useLyrics";

export const RadioPlayerRow = (props: {
    className?: string,
    radio: RadioItemType,
}) => {

    const a = useRef<HTMLAnchorElement|null>(null);
    const { data: now} = useQuery(useNowSongKey(props.radio.radioSlug));
    const isSafari = useIsSafari();
    const showLyrics = useLyrics();

    const onClick = (e:React.MouseEvent<HTMLDivElement, MouseEvent>)=>{
        if (now && now.lyricsRadioSlug) {
            showLyrics(props.radio.radioSlug, now.id);
        }
    }


    return <RouteLink  to={routes.radio_homepage(props.radio.radioSlug)}
                 className={`${props.className ?? ""} ${RadioCss.LinkRow} ${RadioCss.PlayerRow} d-flex flex-row align-items-start `}>
        <LogoPlayerRow onClick={onClick} src={now && now.image ? now.image : props.radio.image} alt={props.radio.radioName}
                       className={`align-self-center ${RadioCss.LogoRow}`}/>
        <div className="align-self-center">
            <FlowText text={props.radio.radioName} parent={a} className={`${RadioCss.radio} ${RadioCss.nameRadio}  ${isSafari.noGap ? "text-color-gradient-safari" :"text-color-gradient" }`}/>
            {now && now.active ? <>
                {now.interpret ? <FlowText onClick={onClick} text={now.interpret} className={RadioCss.nameProgram} parent={a}/> : null}
                {now.song ?<FlowText onClick={onClick} parent={a} className={RadioCss.nameSpan} text={now.song}/> : null}
            </>: (props.radio.radioSlogan ? <FlowText text={props.radio.radioSlogan} parent={a} /> : null)}
        </div>
    </RouteLink>
}